import { render, staticRenderFns } from "./SatinalmaTeklifleri.vue?vue&type=template&id=1f63e199&"
import script from "./SatinalmaTeklifleri.vue?vue&type=script&lang=js&"
export * from "./SatinalmaTeklifleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports